export const DEFAULT_EVENT_TOOLTIP = {
  op: 'ui',
  name: 'Stack',
  sx: { width: '400px' },
  spacing: 1,
  children: [
    {
      op: 'ui',
      name: 'Stack',
      direction: 'row',
      spacing: 1,
      justifyContent: 'space-between',
      alignItems: 'center',
      sx: { px: 1 },
      children: [
        {
          op: 'ui',
          name: 'Stack',
          direction: 'row',
          alignItems: 'center',
          spacing: 1,
          flex: 1,
          children: [
            {
              op: 'ui',
              name: 'Box',
              color: {
                op: 'context',
                path: 'eventStyles.styling.backgroundColor',
              },
              sx: {
                width: '32px',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              },
              children: {
                op: 'ui',
                name: 'Icon',
                icon: 'CircleIcon',
                'data-testid': 'circle-icon',
              },
            },
            {
              op: 'ui',
              name: 'Stack',
              justifyContent: 'center',
              children: [
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'body2',
                  children: {
                    op: 'context',
                    path: 'primary',
                  },
                },
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'caption',
                  children: {
                    op: 'context',
                    path: 'secondary',
                  },
                },
              ],
            },
          ],
        },
        {
          op: 'ui',
          name: 'Stack',
          flex: 1,
          alignItems: 'flex-end',
          children: [
            {
              op: 'ui',
              name: 'Typography',
              variant: 'body2',
              children: {
                op: 'ui',
                name: 'FormatTimestamp',
                format: 'relative',
                value: {
                  op: 'context',
                  path: 'occurred',
                },
              },
            },
            {
              op: 'ui',
              name: 'Typography',
              variant: 'caption',
              sx: { p: 0 },
              children: {
                op: 'ui',
                name: 'FormatTimestamp',
                value: {
                  op: 'context',
                  path: 'occurred',
                },
              },
            },
          ],
        },
      ],
    },
    {
      op: 'if',
      condition: {
        op: 'context',
        path: 'summarizedEventsJsx',
      },
      then: {
        op: 'ui',
        name: 'Typography',
        variant: 'caption',
        align: 'right',
        children: {
          op: 'context',
          path: 'summarizedEventsJsx',
        },
      },
      else: null,
    },
    {
      op: 'ui',
      name: 'Divider',
      sx: { mb: 2 },
    },
    {
      op: 'ui',
      name: 'PopoverDataRow',
      title: {
        op: 'context',
        path: 'item.display',
      },
      label: {
        op: 'context',
        path: 'thingType.display',
      },
      avatar: {
        op: 'ui',
        name: 'Icon',
        icon: 'ThingIcon',
        'data-testid': 'thing-icon',
      },
    },
    {
      op: 'ui',
      name: 'PopoverDataRow',
      wrap: true,
      direction: 'column-reverse',
      title: {
        op: 'ui',
        name: 'EventAddress',
        location: {
          op: 'context',
          path: 'event.data.location',
        },
        dataLoaded: {
          op: 'context',
          path: 'dataLoaded',
        },
        loadingComponent: {
          op: 'ui',
          name: 'Skeleton',
          height: '20px',
          width: '100%',
        },
        variant: 'dataCardTitle',
        addressUnavailableText: {
          op: 'translate',
          translation: 'common:page.thing-map.address-unavailable.hint',
        },
        dataTestId: 'thing-map-popup-address',
      },
      avatar: {
        op: 'ui',
        name: 'Avatar',
        icon: {
          op: 'if',
          condition: {
            op: 'before-past',
            timestamp: {
              op: 'feature-latest-occurred',
              feature: 'tracking',
              havingPath: 'event.data.location',
            },
            duration: 'P7D',
          },
          then: 'LocationUnknownIcon',
          else: 'LocationIcon',
        },
        iconSize: 'small',
        iconColor: {
          op: 'context',
          path: 'theme.dataCard.contrastText',
        },
        background: 'transparent',
      },
      label: [
        {
          op: 'context',
          path: 'event.data.location.latitude',
        }, ', ',
        {
          op: 'context',
          path: 'event.data.location.longitude',
        },
      ],
    },
    {
      op: 'ui',
      name: 'Stack',
      direction: 'row',
      spacing: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      children: [
        {
          op: 'if',
          condition: {
            op: 'context',
            path: 'event.data.velocity',
          },
          then: {
            op: 'ui',
            name: 'PopoverDataRow',
            title: {
              op: 'context',
              path: 'speedText',
            },
            label: {
              op: 'translate',
              translation: 'common:component.events.labels.speed',
            },
            avatar: {
              op: 'ui',
              name: 'Avatar',
              icon: 'SpeedIcon',
              iconSize: 'small',
              iconColor: {
                op: 'context',
                path: 'theme.dataCard.contrastText',
              },
              background: 'transparent',
            },
          },
          else: null,
        },
        {
          op: 'if',
          condition: {
            op: 'context',
            path: 'event.data.velocity',
          },
          then: {
            op: 'ui',
            name: 'PopoverDataRow',
            label: {
              op: 'translate',
              translation: 'terms.direction_one',
              options: { ns: 'common' },
            },
            avatar: {
              op: 'ui',
              name: 'Box',
              sx: {
                op: 'merge',
                objects: [
                  {
                    op: 'context',
                    path: 'directionSx',
                  },
                  {
                    display: 'inline-block',
                    transformOrigin: 'center',
                  },
                ],
              },
              children: {
                op: 'ui',
                name: 'Icon',
                icon: 'NavigationIcon',
              },
            },
            title: {
              op: 'if',
              condition: {
                op: '>',
                left: {
                  op: 'context',
                  path: 'event.data.velocity.heading',
                },
                right: {
                  op: 'literal',
                  value: -1,
                },
              },
              then: {
                op: 'cardinal-direction',
                angle: {
                  op: 'context',
                  path: 'event.data.velocity.heading',
                },
              },
              else: {
                op: 'translate',
                translation: 'component.events.labels.not-moving',
                options: { 'ns': 'common' },
              },
            },
          },
          else: null,
        },
      ],
    },
  ],
};
